// extracted by mini-css-extract-plugin
export var infoItem = "_q1-2";
export var title = "_q1-0";
export var value = "_q1-1";